module.exports = __webpack_public_path__ + "8826974e6e583ac8550e38682d663a2b.svg";